export const tr = {
    'empty-header': 'Negatif anahtar sözcük grupları seçilmedi',
    'empty-text': 'Reklam grubuna ekleyebileceğiniz negatif anahtar sözcük gruplarının listesi burada gösterilir',
    'remove-action': 'Listeyi temizle',
    title: 'Negatif anahtar sözcük grupları'
};
